import {
  CREATE_EXPERT_BOOKING_REQUEST,
  CREATE_EXPERT_BOOKING_SUCCESS,
  CREATE_EXPERT_BOOKING_FAIL,
  FETCH_MY_EXPERT_BOOKINGS_REQUEST,
  FETCH_MY_EXPERT_BOOKINGS_SUCCESS,
  FETCH_MY_EXPERT_BOOKINGS_FAIL,
  FETCH_EXPERT_BOOKING_BY_ID_REQUEST,
  FETCH_EXPERT_BOOKING_BY_ID_SUCCESS,
  FETCH_EXPERT_BOOKING_BY_ID_FAIL,
  UPDATE_EXPERT_BOOKING_STATUS_REQUEST,
  UPDATE_EXPERT_BOOKING_STATUS_SUCCESS,
  UPDATE_EXPERT_BOOKING_STATUS_FAIL,
  UPDATE_EXPERT_BOOKING_SCHEDULING_REQUEST,
  UPDATE_EXPERT_BOOKING_SCHEDULING_SUCCESS,
  UPDATE_EXPERT_BOOKING_SCHEDULING_FAIL,
  RESET_EXPERT_BOOKINGS_ERROR,
} from "./expertBookingsTypes";

const initialState = {
  myBookings: [],
  selectedBooking: null,
  loadingList: false,
  loadingMutation: false,
  loadingSelected: false,
  error: null,
};

export const expertBookingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_EXPERT_BOOKING_REQUEST:
    case UPDATE_EXPERT_BOOKING_STATUS_REQUEST:
    case UPDATE_EXPERT_BOOKING_SCHEDULING_REQUEST:
      return {
        ...state,
        loadingMutation: true,
        error: null,
      };
    case CREATE_EXPERT_BOOKING_SUCCESS:
      return {
        ...state,
        loadingMutation: false,
        myBookings: [...state.myBookings, action.payload],
      };
    case UPDATE_EXPERT_BOOKING_STATUS_SUCCESS:
    case UPDATE_EXPERT_BOOKING_SCHEDULING_SUCCESS:
      return {
        ...state,
        loadingMutation: false,
        myBookings: state.myBookings.map((booking) =>
          booking._id === action.payload?._id ? action.payload : booking,
        ),
        selectedBooking:
          state.selectedBooking &&
          state.selectedBooking._id === action.payload?._id
            ? action.payload
            : state.selectedBooking,
      };
    case CREATE_EXPERT_BOOKING_FAIL:
    case UPDATE_EXPERT_BOOKING_STATUS_FAIL:
    case UPDATE_EXPERT_BOOKING_SCHEDULING_FAIL:
      return {
        ...state,
        loadingMutation: false,
        error: action.payload,
      };

    case FETCH_MY_EXPERT_BOOKINGS_REQUEST:
      return {
        ...state,
        loadingList: true,
        error: null,
      };
    case FETCH_MY_EXPERT_BOOKINGS_SUCCESS:
      return {
        ...state,
        loadingList: false,
        myBookings: Array.isArray(action.payload) ? action.payload : [],
      };
    case FETCH_MY_EXPERT_BOOKINGS_FAIL:
      return {
        ...state,
        loadingList: false,
        error: action.payload,
      };

    case FETCH_EXPERT_BOOKING_BY_ID_REQUEST:
      return {
        ...state,
        loadingSelected: true,
        error: null,
      };
    case FETCH_EXPERT_BOOKING_BY_ID_SUCCESS:
      return {
        ...state,
        loadingSelected: false,
        selectedBooking: action.payload,
      };
    case FETCH_EXPERT_BOOKING_BY_ID_FAIL:
      return {
        ...state,
        loadingSelected: false,
        error: action.payload,
      };

    case RESET_EXPERT_BOOKINGS_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
